import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="text-2xl font-heading tracking-wide text-background-50 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              就去色色
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              探索色彩美学与视觉创作的灵感平台。专注色彩搭配、视觉美学与创意设计灵感，为设计师、摄影师和艺术爱好者提供最全面的色彩资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/category/color-theory"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  色彩理论
                </Link>
              </li>
              <li>
                <Link
                  to="/category/color-schemes"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  配色方案
                </Link>
              </li>
              <li>
                <Link
                  to="/category/design-inspiration"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  设计灵感
                </Link>
              </li>
              <li>
                <Link
                  to="/category/visual-aesthetics"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  视觉美学
                </Link>
              </li>
              <li>
                <Link
                  to="/category/creative-tools"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  创意工具
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/article/color-wheel-basics"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  色彩轮盘：理解色环的基础与应用
                </Link>
              </li>
              <li>
                <Link
                  to="/article/color-psychology-emotions"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  色彩心理学：每种颜色背后的情感密码
                </Link>
              </li>
              <li>
                <Link
                  to="/article/chinese-traditional-colors"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  中国传统色：五色观中的东方智慧
                </Link>
              </li>
              <li>
                <Link
                  to="/article/complementary-color-guide"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  互补色搭配指南：让对比产生美
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <a
                  href="mailto:hello@jiuqu.sese"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors"
                >
                  hello@jiuqu.sese
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 就去色色. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#"
              className="text-background-400 hover:text-primary-300 transition-colors"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-background-400 hover:text-primary-300 transition-colors"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-background-400 hover:text-primary-300 transition-colors"
              aria-label="小红书"
            >
              <i className="ri-chat-smile-2-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}